import { render, staticRenderFns } from "./UserAvailability.vue?vue&type=template&id=6505d1ac&scoped=true"
import script from "./UserAvailability.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserAvailability.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UserAvailability.vue?vue&type=style&index=0&id=6505d1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505d1ac",
  null
  
)

export default component.exports